<template>
  <div class="py-3 px-2">
    <!-- <div v-if="isSenditUser && !hasFallbackConfigured" class="mb-2">
      <label class="label-custom">
        {{ $t('settings.twoWay.newConfiguration.add-keyword.modal.fallback') }}
      </label>
      <CSwitch color="primary" shape="pill" class="ml-3 pt-2" :checked="fallback" :disabled="loading" @update:checked="updateFallbackSwitch" />
    </div> -->
    <div v-if="!isFallback" class="mb-2">
      <CRow class="mt-1">
        <CCol>
          <label class="label-custom required">
            {{ $t('settings.twoWay.newConfiguration.add-keyword.modal.keyword') }}
          </label>
          <CInput
            :value.sync="$v.keyword.$model"
            :disabled="loading || fallback"
            :isValid="!$v.keyword.$error"
            :invalidFeedback="
              !$v.keyword.required
                ? $t('settings.twoWay.newConfiguration.add-keyword.modal.validation.keyword.required')
                : !$v.keyword.hasNoWhiteSpaces
                ? 'Não pode espaços em branco'
                : ''
            "
            @blur="handlerKeyword"
          />
        </CCol>
        <CCol md="3" class="text-center">
          <label class="label-custom">
            {{ $t('settings.twoWay.newConfiguration.add-keyword.modal.wildcard.label') }}
            <CIcon
              name="question"
              size="custom-size"
              :height="14"
              viewBox="0 0 32 32"
              v-c-tooltip="{
                content: $t('settings.twoWay.newConfiguration.add-keyword.modal.wildcard.tooltip'),
                placement: 'bottom-start',
              }"
            />
          </label>
          <CInputCheckbox class="mt-2" :disabled="loading || fallback" :checked="wildcard" @update:checked="updateWildcardSwitch" />
        </CCol>
      </CRow>
      <span class="text-gray-400" style="font-size: 14px">{{ $t('settings.twoWay.newConfiguration.add-keyword.modal.keywordTip') }}</span>
    </div>
    <div class="mt-1">
      <label class="label-custom">
        {{ $t('settings.twoWay.newConfiguration.add-keyword.modal.add-ansewer') }}
      </label>
      <CSwitch color="primary" shape="pill" class="ml-3 pt-2" :checked="hasResponse" :disabled="loading" @update:checked="updateAnswerSwitch" />
    </div>
    <div class="mt-1">
      <CCollapse :show="hasResponse">
        <SMSTemplateTextarea
          ref="answerArea"
          :loaded-message-text="responseText"
          :isMessageInvalid="$v.responseText.$error"
          :messageInvalidFeedback="$t('settings.twoWay.newConfiguration.add-keyword.modal.validation.keyword.required')"
          :disabled="loading"
          @message-changed="handleSMSMessageChanged"
        />
      </CCollapse>
    </div>
    <div class="mt-1">
      <label class="label-custom">
        {{ $t('settings.twoWay.newConfiguration.add-keyword.modal.endpoint') }}
      </label>
      <CSwitch color="primary" shape="pill" class="ml-3 pt-2" :checked="hasEndpoint" :disabled="loading" @update:checked="updateEndpointSwitch" />
    </div>
    <div class="mt-1">
      <CCollapse :show="hasEndpoint">
        <label class="label-custom">
          {{ $t('settings.twoWay.newConfiguration.add-keyword.modal.label.endpoint') }}
        </label>
        <CInput
          placeholder="https://..."
          :value.sync="endpoint"
          :disabled="loading"
          :isValid="!$v.endpoint.$error"
          :invalidFeedback="
            !$v.endpoint.required
              ? $t('settings.twoWay.newConfiguration.add-keyword.modal.validation.keyword.required')
              : !$v.endpoint.url
              ? $t('settings.twoWay.newConfiguration.add-keyword.modal.validation.endpoint.valid-url')
              : ''
          "
          @input="$v.endpoint.$touch()"
        />
      </CCollapse>
    </div>
    <div class="mt-3 text-right">
      <CButton color="white" class="px-4 mr-2 border" :disabled="loading" @click="cancelNewKeyword()">{{
        $t('settings.twoWay.newConfiguration.add-keyword.modal.button.cancel')
      }}</CButton>
      <CButton color="primary" class="px-4" :disabled="loading" @click="saveKeyword()">
        {{ $t('settings.twoWay.newConfiguration.add-keyword.modal.button.confirm') }}
      </CButton>
    </div>
  </div>
</template>

<script>
import SMSTemplateTextarea from '@/components/SMSTemplateTextarea.vue'
import { url, requiredIf } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import services from '@/services.js'

// {
//   "organizationAccessNumberId": "d693f57d-6255-4b49-a482-cdb46024b86d",
//   "name": "teste1",
//   "isWildcard": true,
//   "isDefault": false,
//   "webhooksUrl": "http://teste.com",
//   "keywordBehaviours": [
//       1,
//       3,
//       2,
//       4
//   ],
//   "keywordStatus": 1,
//   "createdByUserId": "40557794-ea78-4dd0-8906-017032be47e0",
//   "automaticResponses": [],
//   "id": "acfbbc01-7f7a-46ab-a221-e74e42a1ecb9",
//   "createdDateTime": "2024-11-25T15:41:10.635971",
//   "updatedDateTime": null,
//   "createdBy": "Maria Oliveiraaa",
//   "lastUpdatedBy": null
// }
const spaceRegex = /\s+/
// CUSTOM VALIDATOR
const hasNoWhiteSpaces = (value) => (value ? !spaceRegex.test(value) : true)

export default {
  name: 'KeywordForm',
  mixins: [validationMixin],
  components: {
    SMSTemplateTextarea,
  },
  props: {
    organizationAccessNumberId: {
      type: String,
    },
    keywordId: {
      type: String,
      default: null,
    },
    isFallback: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasResponse: false,
      hasEndpoint: false,
      fallback: false,
      keyword: '',
      wildcard: false,
      responseText: null,
      endpoint: null,
      loading: false,
    }
  },
  computed: {
    isSenditUser() {
      return this.$store.getters['auth/isSendit']
    },
  },
  validations() {
    return {
      keyword: {
        required: requiredIf(() => !this.isFallback),
        hasNoWhiteSpaces,
      },
      responseText: {
        required: requiredIf(() => this.hasResponse),
      },
      endpoint: {
        url,
        required: requiredIf(() => this.hasEndpoint),
      },
    }
  },

  mounted() {
    if (this.keywordId) {
      this.getKeyword()
    }
  },

  methods: {
    removeWhiteSpace(e) {
      if (e.keyCode === 32) e.preventDefault()
    },
    getKeyword() {
      this.loading = true

      const organizationId = this.$route.params.organizationId

      services
        .getTwoWayKeyword(organizationId, this.organizationAccessNumberId, this.keywordId)
        .then((res) => {
          this.fallback = res.data.data.isDefault
          this.keyword = res.data.data.name
          this.wildcard = res.data.data.isWildcard
          const [response] = res.data.data.automaticResponses

          if (response) {
            this.responseText = response.text
            this.hasResponse = true
          }

          this.endpoint = res.data.data.webhooksUrl
          this.hasEndpoint = res.data.data.webhooksUrl ? true : false
        })
        .catch(({ response }) => {
          const message = {
            status: 'danger',
            text: response.data.message,
          }
          this.$emit('creation-error', message)
        })
        .finally(() => (this.loading = false))
    },

    clearData() {
      this.$v.$reset()
      this.hasResponse = false
      this.hasEndpoint = false
      this.fallback = false
      this.keyword = null
      this.wildcard = false
      this.responseText = null
      this.endpoint = null
      this.loading = false
    },
    handleSMSMessageChanged(msgValue) {
      this.responseText = msgValue
    },
    handlerKeyword() {
      this.keyword = this.keyword?.toLowerCase()
    },
    updateFallbackSwitch(value) {
      this.fallback = value
      if (value) {
        this.wildcard = true
      } else {
        this.keyword = ''
        this.wildcard = false
      }
    },
    updateWildcardSwitch(value) {
      this.wildcard = value
    },
    updateAnswerSwitch(value) {
      this.$refs.answerArea.clearText()
      this.responseText = null
      this.hasResponse = value
      this.$v.responseText.$reset()
    },
    updateEndpointSwitch(value) {
      this.hasEndpoint = value
      this.endpoint = null
      this.$v.endpoint.$reset()
    },
    cancelNewKeyword() {
      this.$emit('close-modal')
    },

    saveKeyword() {
      this.$v.$touch()

      if (this.$v.$invalid) return

      const organizationId = this.$route.params.organizationId
      this.loading = true

      const body = {
        name: this.keyword,
        isDefault: this.isFallback,
        isWildcard: this.wildcard,
        hasResponseMessage: this.hasResponse,
        responseMessage: this.responseText,
        hasEndpoint: this.hasEndpoint,
        endpoint: this.endpoint,
        isOptOut: false, // COMPORTAMENTO DEIXADO POR PADRAO EM VIRTUDE DE EVITAR A CRIAÇAO DE BEHAVIORS NO BACKEND
        isOptIn: false,
      }
      // UPDATE
      if (this.keywordId) {
        services
          .updateTwoWayKeyword(organizationId, this.organizationAccessNumberId, this.keywordId, body)
          .then(() => {
            const message = {
              status: 'success',
              text: !this.isFallback
                ? this.$t('settings.twoWay.newConfiguration.modal.keyword.update-success')
                : this.$t('settings.twoWay.newConfiguration.modal.fallback.update-success'),
            }

            this.$emit('creation-success', message)
          })
          .catch(({ response }) => {
            const message = {
              status: 'danger',
              text: response.data.message,
            }
            this.$emit('creation-error', message)
          })
          .finally(() => (this.loading = false))
      } else {
        // CREATE
        services
          .createTwoWayNewKeyword(organizationId, this.organizationAccessNumberId, body)
          .then(() => {
            const message = {
              status: 'success',
              text: this.$t('settings.twoWay.newConfiguration.modal.keyword.create-success'),
            }

            this.$emit('creation-success', message)
          })
          .catch(({ response }) => {
            const message = {
              status: 'danger',
              text: response.data.message,
            }
            this.$emit('creation-error', message)
          })
          .finally(() => (this.loading = false))
      }
    },
  },
}
</script>
